import { AxiosError, AxiosRequestConfig } from 'axios';
import { logoutSuccess } from 'features/auth/redux/actions';
import store from 'store';
import { localStorage } from '../utils';
import { authPaths } from 'features/auth/routes/paths';
import { getCurrentLanguage } from 'utils/getCurrentLanguage';

const getLanguageHeader = () => {
  const currentLanguage = getCurrentLanguage()
  return [currentLanguage, navigator.language].join(',')
}

// TODO: add token caching in memory
export const requestHandler = (config: AxiosRequestConfig) => {
  const token = localStorage.getToken();
  if (token) {
    config.headers = {
      Authorization: `Token ${token}`,
      "Accept-Language": getLanguageHeader(),
    };
  }
  return config;
};

export const errorHandler = (error: AxiosError) => {
  if (error.response?.status === 401) {
    localStorage.clearAuthData();
    window.location.href = `${window.location.origin}${authPaths.static.login}`;
    store.dispatch(logoutSuccess());
  }

  return Promise.reject(error);
};
